var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-anchor',{attrs:{"affix":true},on:{"click":_vm.tobox,"change":_vm.onChange}},_vm._l((_vm.list),function(item,index){return _c('a-anchor-link',{key:index,attrs:{"href":item.href,"title":item.title}},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rowtitle == item.title),expression:"rowtitle == item.title"}],staticClass:"box",style:({
                    borderBottom:
                        _vm.rowtitle == item.title
                            ? '3px solid #0037CC'
                            : '3px solid transparent'
                })})])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }